import { Route, Switch } from 'react-router-dom';
import Application from './containers/Application';
import ConnectAppContainer from './containers/ConnectAppContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Routes() {
  return /*#__PURE__*/_jsx(Application, {
    children: /*#__PURE__*/_jsx(Switch, {
      children: /*#__PURE__*/_jsx(Route, {
        exact: true
        // @ts-expect-error name is not a prop on route
        ,
        name: "authorize",
        path: "/authorize",
        component: ConnectAppContainer
      })
    })
  });
}